'use strict';

/**
 * Locale catalog registry.
 *
 * To add a language:
 *   1. Copy `en-AU.js` → `xx-YY.js` (or `xx.js`)
 *   2. Translate the string values (keep keys identical)
 *   3. Register it below
 *   4. Optionally map regions in `LANGUAGE_DEFAULTS` / `REGION_BY_LANGUAGE` in `../index.js`
 */
const enAU = require('./en-AU');
const enUS = require('./en-US');
const esUS = require('./es-US');
const esES = require('./es-ES');
const deDE = require('./de-DE');

const locales = Object.freeze({
  'en-AU': enAU,
  'en-US': enUS,
  'es-US': esUS,
  'es-ES': esES,
  'de-DE': deDE
});

const DEFAULT_LOCALE = 'en-AU';

module.exports = {
  locales,
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES: Object.freeze(Object.keys(locales))
};
